export const UserTypeCode = {
  CONTRACTOR: '870520001',
  SUPPLIER: '870520003'
};

export const UserTypeCodeAus = {
  CONTRACTOR: '870520001',
  SUPPLIER: '870520003'
};